import _slicedToArray from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import BigNumber from 'bignumber.js';
import { useEffect, useState, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from "../../../../state/hooks";
import { useBestBuyPair, useBestBuyInputAmount, useBestBuyUserConfig } from "../../../../state/dex/hooks";
import { updateBestBuyInputAmount } from "../../../../state/dex/actions";
import { useWeb3React } from '@web3-react/core';
import { formatPercentage, formatFormAmount } from "../../../../utils/numbers";
import { InputAmountStatus, useMinMaxAmountVerify, useActiveBalanceVerify } from "../../hooks/useTradeVerify";
import { useAvailableTokenBalance } from "../../hooks/useAvailableTokenBalance";
import { Row, StyledRowLabel, StyledInputWrapper, Input, InputHelpText, StyledReferWrapper, StyledReferLabel, StyledReferItemsWrapper, StyledReferItem, Divider, StyledErrorMsg } from "../../styled";
import styled from 'styled-components';
var quicklySelectionArray = [0.25, 0.5, 0.75, 1];

var BuyAmountInput = () => {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useWeb3React = useWeb3React(),
      account = _useWeb3React.account;

  var dispatch = useAppDispatch();

  var _useBestBuyPair = useBestBuyPair(),
      _useBestBuyPair2 = _slicedToArray(_useBestBuyPair, 1),
      inputToken = _useBestBuyPair2[0];

  var _useBestBuyInputAmoun = useBestBuyInputAmount(),
      inputAmount = _useBestBuyInputAmoun.inputAmount;

  var _useBestBuyUserConfig = useBestBuyUserConfig(),
      expiration = _useBestBuyUserConfig.expiration;

  var _expiration$split = expiration.split('_'),
      _expiration$split2 = _slicedToArray(_expiration$split, 1),
      expirationValue = _expiration$split2[0];

  var verifyMinMaxAmount = useMinMaxAmountVerify();

  var _useState = useState(InputAmountStatus.DEFAULT),
      status = _useState[0],
      setStatus = _useState[1];

  var buyAmountRef = useRef(null);
  var availableBalance = useAvailableTokenBalance(account, inputToken);
  var balance = formatFormAmount(availableBalance.toDecimalsFixed(), 4);
  var verifyActiveBalance = useActiveBalanceVerify();
  var borderColor = useMemo(() => {
    if (status === InputAmountStatus.DEFAULT || status === InputAmountStatus.VERIFIED) return '#e8e9f2';
    return '#e75b55';
  }, [status]);

  var onChange = e => {
    var value = e.target.value;
    if (value === '') return dispatch(updateBestBuyInputAmount({
      inputAmount: ''
    }));
    var intValue = parseInt(value);

    if (!isNaN(intValue) && intValue >= 0) {
      dispatch(updateBestBuyInputAmount({
        inputAmount: intValue.toString()
      }));
    }
  };

  var onSelect = factor => {
    var amount = new BigNumber(balance).multipliedBy(factor).toFixed(0);
    dispatch(updateBestBuyInputAmount({
      inputAmount: amount
    }));
  };

  useEffect(() => {
    if (inputAmount === '') return setStatus(InputAmountStatus.DEFAULT);
    var minMaxResult = verifyMinMaxAmount(inputAmount, expirationValue);

    if (minMaxResult !== InputAmountStatus.VERIFIED) {
      setStatus(minMaxResult);
    } else if (!!account) {
      var activeBalanceResult = verifyActiveBalance();
      setStatus(activeBalanceResult);
    } else {
      setStatus(InputAmountStatus.VERIFIED);
    }
  }, [account, inputAmount, expirationValue]);
  return __jsx(Row, null, __jsx(StyledLabelWrapper, null, __jsx(StyledRowLabel, null, t('total_amount')), !!account && __jsx(StyledBalanceLabel, null, t('available_balance'), ": ", balance, " ", inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol)), __jsx(StyledInputWrapper, {
    borderColor: borderColor,
    onClick: () => {
      var _buyAmountRef$current;

      buyAmountRef === null || buyAmountRef === void 0 || (_buyAmountRef$current = buyAmountRef.current) === null || _buyAmountRef$current === void 0 ? void 0 : _buyAmountRef$current.focus();
    }
  }, __jsx(Input, {
    ref: buyAmountRef,
    inputMode: "numeric",
    onChange: onChange,
    placeholder: "0",
    value: inputAmount,
    width: "".concat(Math.max(inputAmount.length * 10, 40), "px")
  }), __jsx(InputHelpText, null, inputToken === null || inputToken === void 0 ? void 0 : inputToken.symbol)), status === InputAmountStatus.MAX_AMOUNT_ERROR && __jsx(StyledErrorMsg, null, t('best_buy_verify_max_amount_error')), status === InputAmountStatus.BALANCE_OCCUPIED_ERROR && __jsx(StyledErrorMsg, null, t('best_buy_verify_balance_occupied_error')), __jsx(StyledReferWrapper, null, __jsx(StyledReferLabel, null, t('reference')), __jsx(StyledReferItemsWrapper, null, quicklySelectionArray.map((item, index) => {
    return __jsx(StyledReferItem, {
      key: index,
      onClick: () => onSelect(item)
    }, index !== 0 && __jsx(Divider, null), formatPercentage(item));
  }))));
};

export default BuyAmountInput;
var StyledLabelWrapper = styled.div.withConfig({
  displayName: "StyledLabelWrapper",
  componentId: "sc-gp1tev-0"
})(["display:flex;justify-content:space-between;align-items:center;"]);
var StyledBalanceLabel = styled.div.withConfig({
  displayName: "StyledBalanceLabel",
  componentId: "sc-gp1tev-1"
})(["color:#7f8294;font-size:12px;font-weight:400;line-height:16px;"]);